import {memo} from 'react';
import parse from 'html-react-parser';
import Icon from '@/components/atoms/Icon';
import styles from './CheckList.module.scss';

interface CheckListProps {
    /** One entry per line; HTML from the content files (links, bold) is rendered. */
    items?: string[];
    /** Replaces the default body text style of each line (the line keeps `font-regular-text`). */
    textClassName?: string;
}

/**
 * A list of points, each with an outlined check icon, as used inside the service cards. The container renders even with
 * no items (it keeps the cards' spacing the same as before).
 */
const CheckList = ({items, textClassName}: CheckListProps) => (
    <div className={styles.points}>
        {items?.map((point, index) => (
            <div key={index}>
                <div className={styles.point}>
                    <div className={styles.pointIcon}>
                        <Icon name="CheckCircleOutlineOutlined" fontSize="small" />
                    </div>
                    <p className={`font-regular-text ${textClassName ?? styles.text}`}>{point ? parse(point) : ''}</p>
                </div>
            </div>
        ))}
    </div>
);

export default memo(CheckList);
